// extracted by mini-css-extract-plugin
export default {"title":"AdditionalContent_title__RZExF","heading":"AdditionalContent_heading__eo1Bg","jsonInfoWraper":"AdditionalContent_jsonInfoWraper__xowon"};